export default () => ({
  nombre: "",
  apellido: "",
  email: "",
  locacionId: "",
  status: true,
});
